export default class MobileAppMessagingDriver {
  static postMessage(...args) {
    if (typeof window === 'undefined') {
      return false;
    }

    if (!('webkit' in window) && !('appInterface' in window)) {
      console.log('MobileAppMessagingDriver:postMessage', ...args);
      console.warn('webkit or appInterface is not recognized!');
      return false;
    }

    if ('webkit' in window) {
      window.webkit.messageHandlers.observer.postMessage(...args);
    } else {
      window.appInterface.postMessage(JSON.stringify({ ...args }));
    }

    return true;
  }

  static openUrl(url) {
    this.postMessage({
      action: 'openUrl',
      value: url,
    });
  }

  static openScreen(screen) {
    this.postMessage({
      action: 'screen',
      value: screen,
    });
  }

  static sendAnalitics(message) {
    return this.postMessage({
      action: 'analytics',
      value: message,
    });
  }
}
